<template>
  <div>
    <!--    style="overflow:auto;height: 100vh" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-immediate="false"-->
    <el-container>
      <el-header style="height: 80px">
        <img v-show="activeName === 'first'" src="../assets/img/123.png" style="height: 80px;">
        <img v-if="activeName === 'second'" src="../assets/img/1.jpg" style="height: 80px;width: 239px">
        <img v-if="activeName === 'third'" src="../assets/img/2.jpg" style="height: 80px;width: 239px">
      </el-header>
      <el-main>
        <el-alert
          v-if="mpSessionInvalid"
          title="登录已过期，请返回小程序重新打开"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 8px;"
        />
        <el-tabs v-model="activeName" tab-position="bottom" type="border-card" stretch >
          <el-tab-pane name="first">
            <span slot="label">
          <i class="el-icon-s-home" style="margin-right: 5px"></i>
          公示台
        </span>
            <announcement-platform></announcement-platform>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label"><i class="el-icon-s-comment" style="margin-right: 5px"></i>投诉</span>
            <complaint-form :deptcode="deptcode" :mp-session="mpSession"></complaint-form>
          </el-tab-pane>
          <el-tab-pane name="third">
            <span slot="label">
            <i class="el-icon-s-promotion" style="margin-left: 5px"></i>建议</span>
            <suggestion-form :deptcode="deptcode" :mp-session="mpSession"></suggestion-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>

</template>


<script>
import announcementPlatform from './announcementPlatform.vue'
import complaintForm from "./ComplaintForm.vue";
import suggestionForm from "./SuggestionForm.vue";
import { resolveMpSession } from '../utils/mpSession';

export default {
  name: "index",
  components: {
    announcementPlatform,
    complaintForm,
    suggestionForm
  },
  data() {
    return {
      activeName: 'first',
      deptcode: '',
      mpSession: '',
      mpSessionInvalid: false,
    }
  },
  created() {
    const deptcode = this.$route.query.deptcode;
    if (deptcode) {
      this.deptcode = deptcode;
    }
    // 小程序 webview 通过 ?entry=mp&session= 带入 token
    const { entry, session } = resolveMpSession(this.$route.query);
    if (session) {
      this.mpSession = session;
      this.verifyMpSession(session);
      if (entry === 'mp') {
        this.activeName = 'second';
      }
    }
  },
  methods:{
    async verifyMpSession(session) {
      try {
        const res = await this.$http.post('/complaint/session/verify', { sessionToken: session });
        if (String(res.code) !== '1' || !res.data || !res.data.valid) {
          this.mpSessionInvalid = true;
        }
      } catch (e) {
        // verify 失败不阻断提交，最终以 POST /complaint 服务端验签为准
      }
    }
  }
}
</script>

<style scoped>
el-header {
  height: 100px;
}

.el-main {
  padding: 0;
}

.el-tabs--border-card {
  border: 0;
}

/deep/ .el-tabs__item {
  height: 50px;
  line-height: 50px;
}

/deep/ .el-tabs--bottom .el-tabs__header.is-bottom {
  position: fixed;
  bottom: 0px;
  width: 100%;
  background: #f7f7fa;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #409eff;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue